import * as HttpService from './http.service';
import { DUMP_LOGS_URL } from './url.service';

export const dumpLog = (data) => {
    return HttpService.postWithAuth(DUMP_LOGS_URL, data);
}